import React from 'react';
import Skeleton from 'react-loading-skeleton';

const VoiceSkeleton = ({ voices }) =>
  Array(voices)
    .fill(0)
    .map((item) => (
      <div className="voice-info-skeleton" key={item}>
        <div className="avartar-skeleton">
          <Skeleton circle width={80} height={80} />
        </div>
        <div className="detail-voice-skeleton">
          <div className="voice-name-skeleton">
            <Skeleton />
          </div>
          <div className="features-skeleton">
            <Skeleton />
          </div>
        </div>
      </div>
    ));

export default VoiceSkeleton;
